import React from 'react';
import PropTypes from 'prop-types';
import {
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering,
  RowDetailState,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Table,
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
  TableRowDetail,
} from '@devexpress/dx-react-grid-material-ui';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ReceiptIcon from '@material-ui/icons/Receipt';

import moment from 'moment';

import CustomerNameTypeProvider from './data_type_provider/CustomerNameTypeProvider.js';
import PhoneTypeProvider from './data_type_provider/PhoneTypeProvider.js';

import CountUpTimer from './timer/CountUpTimer.js';
import CheckOutDialog from './CheckOutDialog.js';
import VoidTransactionDialog from './VoidTransactionDialog.js';
import TransactionRemarkDialog from './TransactionRemarkDialog.js';
import PassDialog from './PassDialog.js';

import firebase from 'firebase/app';
require("firebase/firestore");

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

const columns = [
  { name: 'name', title: 'Name' },
  { name: 'phone', title: 'Phone' },
  { name: 'info', title: 'Info' },
  { name: 'checkInTime', title: 'Check-In' },
  { name: 'checkOutTime', title: 'Check-Out' },
  { name: 'status', title: 'Status' },
];

const Cell = (props) => (
  <Table.Cell 
    {...props} 
    style={{
      padding: '0px 8px'
    }} 
  />
);


const TimeTypeProvider = () => (
  <DataTypeProvider
    for={['checkInTime']}
    formatterComponent={({ value }) => value ? moment(value.toDate()).format('LT') : ''}
    editorComponent={() => <div /> } />
);

const CheckOutTypeProvider = () => (
  <DataTypeProvider
    for={['checkOutTime']}
    formatterComponent={({ column, row, value }) => {
      let content = null;
      if (row.checkOutTime) {
        content = value ? moment(value.toDate()).format('LT') : '';
      } else if (row.status !== "voided") {
        content = <CountUpTimer startFrom={row.checkInTime.toDate()} />;
      }
      return content;
    }}
    editorComponent={() => <div /> } />
);

const ButtonTypeProvider = () => (
  <DataTypeProvider
    for={['status']}
    formatterComponent={({ column, row, value }) =>
      row.status === "done" ?
      <Button fullWidth variant="outlined" onClick={row.checkOut}>
        <ReceiptIcon style={{marginRight:8}} />Details
      </Button>
      : row.status === "payment" ?
      <Button fullWidth variant="outlined" color="primary" onClick={row.checkOut}>
        <AttachMoneyIcon style={{marginRight:8}} />Payment
      </Button>
      : row.status === "checkout" ?
      <Button fullWidth variant="outlined" color="primary" onClick={row.checkOut}>
        <ExitToAppIcon style={{marginRight:8}} />Check-Out
      </Button>
      : row.status === "voided" ?
      <Button fullWidth variant="outlined" disabled>
        <Icon style={{marginRight:8}} >clear_all</Icon>Voided
      </Button>
      : null
    }
    editorComponent={({ value, onValueChange }) => <div /> } />
);

class DeskInUseTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      users: this.props.users,

      width: window.innerWidth,
      height: window.innerHeight,

      checkOutDialogOpen: false,
      checkOutTransaction: null,

      voidTransactionDialogOpen: false,
      voidTransaction: null,

      passDialogOpen: false,
      passDialogUserId: null,

      transactionRemarkDialogOpen: false,
      editRemarkTransaction: null,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  queryDeskTransaction = (branchId) => {
    return firebase.firestore()
      .collection("deskTransaction")
      .where('branch', '==', branchId)
      .where('checkInTime', '>=', moment().set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0}).toDate())
      .where('checkInTime', '<=', moment().set({'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 999}).toDate())
      .onSnapshot(querySnapshot => {
        var rows = this.state.rows;
        querySnapshot.docChanges().forEach(function(change) {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id = change.doc.id;
            data.status = data.voided ? "voided" : isNumeric(data.paymentAmount) ? 'done' : data.checkOutTime ? 'payment' : 'checkout';
            data.checkOut = () => {
              this.handleCheckOutDialogOpen(this.state.rows.find((item) => item.id === data.id));
            };

            let user = this.props.users.find(user => { return user.id === data.userId });
            if (user) {
              data.name = user.name;
              data.phone = user.phone;
            }

            let index = rows.findIndex(function(element) {
              return element.id === data.id;
            });
            if (index === -1) {
              rows.push(data);
            } else {
              rows[index] = data;
            }
          }
        }.bind(this));

        this.setState({
          rows: Array.from(rows),
        });
      });
  }

  getDetailRow = ({ row }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      { row.status !== "voided" ? 
        <Button 
          variant="outlined" 
          onClick={() => this.handleVoidTransactionDialogOpen(row)}>
            VOID
        </Button> : 
        null 
      }
      <div style={{ marginLeft: "auto" }}>id: {row.id}</div>
    </div>
  );

  hasValidPass = (userPasses) => {
    if (!userPasses) {
      return false;
    }
    return this.props.passes.filter(pass => pass.active).some(pass => {
      var userPassRecord = userPasses[pass.id];

      switch (pass.unit) {
        case 'time':
        case 'day':
          let remaining = (userPassRecord && userPassRecord.remaining) || 0;
          if (remaining > 0) {
            return true;
          }
  
          if (userPassRecord && userPassRecord.expiryDate) {
            if (moment(userPassRecord.expiryDate.toDate()).isAfter(moment())) {
              return true;
            }
          }

          return false;
        case 'month':
          if (userPassRecord) {
            if (pass.activation && !userPassRecord.activationDate) {
              return true;
            } if (userPassRecord.expiryDate && moment(userPassRecord.expiryDate.toDate()).isAfter(moment())) {
              return true;
            }
          }

          return false;
        default:
          return false;
      }
    })
  }

  handleCheckOutDialogOpen = (deskTransaction) => {
    this.setState({
      checkOutTransaction: deskTransaction,
      checkOutDialogOpen: true,
     });
  }

  handleCheckOutDialogClose = () => {
    this.setState({ checkOutDialogOpen: false });
  }

  // Void
  handleVoidTransactionDialogOpen = (deskTransaction) => {
    this.setState({
      voidTransactionDialogOpen: true,
      voidTransaction: deskTransaction,
    });
  }
  handleVoidTransactionDialogClose = () => {
    this.setState({ voidTransactionDialogOpen: false, });
  }

  // Pass
  handlePassDialogOpen = userId => {
    this.setState({
      passDialogOpen: true,
      passDialogUserId: userId,
    });
  }
  handlePassDialogClose = () => {
    this.setState({ passDialogOpen: false, });
  }

  // Remark
  handleTransactionRemarkDialogOpen = (deskTransaction) => {
    this.setState({
      transactionRemarkDialogOpen: true,
      editRemarkTransaction: deskTransaction,
    });
  }
  handleTransactionRemarkDialogClose = () => {
    this.setState({ transactionRemarkDialogOpen: false, });
  }

  stop = () => {
    this.state.unsubscribeDeskTransaction && this.state.unsubscribeDeskTransaction();
  }

  reload = (branchId) => {
    this.stop();
    this.setState({
      rows: [],
      unsubscribeDeskTransaction: this.queryDeskTransaction(branchId)
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.setState({ unsubscribeDeskTransaction: this.queryDeskTransaction(this.props.branchId) });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    this.stop();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newState = {};
    if (nextProps.users) {
      newState.users = nextProps.users;

      // fetch user info
      const rows = this.state.rows;
      rows.forEach(row => {
        const user = nextProps.users.find(user => user.id === row.userId);
        if (user) {
          row.name = user.name;
          row.phone = user.phone;
        }
      });
      this.setState({rows: Array.from(rows)});
    }
    this.setState(newState);

    if (this.props.branchId !== nextProps.branchId) {
      this.reload(nextProps.branchId);
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return(
      <div>
        <Paper>
          <Grid rows={this.state.rows} columns={columns}>

            <CustomerNameTypeProvider onEdit={row => this.handleTransactionRemarkDialogOpen(row)} />
            <TimeTypeProvider />
            <PhoneTypeProvider for={['phone']} />
            <ButtonTypeProvider />
            <CheckOutTypeProvider />
            <DataTypeProvider
              for={['info']}
              formatterComponent={({ column, row, value }) => 
                <div>
                  { 
                    this.hasValidPass(this.props.userPasses[row.userId]) ?
                    <Tooltip title="Available" placement="top">
                      <Icon style={{ cursor: 'pointer' }} color="primary" onClick={() => this.handlePassDialogOpen(row.userId)}>card_giftcard</Icon>
                    </Tooltip>
                    :
                    this.props.userPasses[row.userId] ?
                    <Tooltip title="All spent" placement="top">
                      <Icon>card_giftcard</Icon>
                    </Tooltip>
                    :
                    <Tooltip title="Never" placement="top">
                      <Icon color="disabled">card_giftcard</Icon>
                    </Tooltip>
                  }
                  { row.isFirstCome ? <Tooltip title="First come" placement="top"><Icon color="action">looks_one</Icon></Tooltip> : null }
                </div>
              }
              editorComponent={() => <div /> }
            />

            <RowDetailState />

            {/* Sorting */}
            <SortingState
              defaultSorting={[ {columnName: 'checkInTime', direction: 'desc'}, ]}/>
            <IntegratedSorting />

            {/* Filter */}
            <FilteringState defaultFilters={[]} />
            <IntegratedFiltering />

            <VirtualTable
              cellComponent={Cell}
              columnExtensions={[
                { columnName: 'name', width: this.state.width - 261 - 48 - 48 - 100 - 80 - 100 - 120 - 140 },
                { columnName: 'phone', width: 100 },
                { columnName: 'info', width: 80 },
                { columnName: 'checkInTime', width: 100 },
                { columnName: 'checkOutTime', width: 120},
                { columnName: 'status', width: 140 },
              ]}
              height={this.state.height - 112} />
            <TableHeaderRow showSortingControls />
            <TableFilterRow />
            <TableRowDetail contentComponent={this.getDetailRow} />

          </Grid>
        </Paper>

        <CheckOutDialog
          open={this.state.checkOutDialogOpen}
          onRequestClose={this.handleCheckOutDialogClose}
          deskTransaction={this.state.checkOutTransaction}
          passes={this.props.passes}
          priceRule={this.props.priceRule}
          userPassRecord={this.state.checkOutTransaction && this.props.userPasses[this.state.checkOutTransaction.userId]}
          customer={this.state.checkOutTransaction && this.props.users.find(user => user.id === this.state.checkOutTransaction.userId)}
          branchId={this.props.branchId} />

        <VoidTransactionDialog
          open={this.state.voidTransactionDialogOpen}
          onRequestClose={this.handleVoidTransactionDialogClose}
          deskTransaction={this.state.voidTransaction} />

        <TransactionRemarkDialog
          open={this.state.transactionRemarkDialogOpen}
          onRequestClose={this.handleTransactionRemarkDialogClose}
          deskTransaction={this.state.editRemarkTransaction} />

        <PassDialog
          open={this.state.passDialogOpen}
          onRequestClose={this.handlePassDialogClose}
          passes={this.props.passes}
          customer={this.props.users.find(user => user.id === this.state.passDialogUserId)}
          userPass={this.props.userPasses[this.state.passDialogUserId]} />

      </div>
    );
  }
}

DeskInUseTable.propTypes = {
  branchId: PropTypes.string.isRequired,
  users: PropTypes.array.isRequired,
  passes: PropTypes.array.isRequired,
  priceRule: PropTypes.array.isRequired,
  userPasses: PropTypes.object.isRequired,
};

export default DeskInUseTable;
